export default "__VITE_ASSET__BBRL9yfh__"